<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>Change Password</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <form #f="ngForm" class="ion-padding" (ngSubmit)="updatePassword(f)">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img
            src="../../../assets/images/MimboLogo.png"
            class="logo"
          ></ion-img>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-list>
            <ion-item color="lightmimbo">
              <ion-label position="floating">Email</ion-label>
              <ion-input
                type="email"
                name="email"
                style="opacity: 0.7"
                readonly
                value="{{email}}"
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="password"
                name="currentPassword"
                ngModel
                required
                label="Current Password"
                labelPlacement="floating"
                minlength="6"
                #currentPasswordCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="password"
                name="newPassword"
                label="New Password"
                labelPlacement="floating"
                ngModel
                required
                minlength="6"
                #newPasswordCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item
              color="lightmimbo"
              *ngIf="!newPasswordCtrl.valid && newPasswordCtrl.touched"
            >
              <ion-text color="danger">
                <small
                  >Password should be at least 6 characters long.</small
                ></ion-text
              >
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="password"
                name="confirmPassword"
                label="Confirm New Password"
                labelPlacement="floating"
                ngModel
                required
                #confirmPasswordCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo" *ngIf="!passwordsMatch" lines="none">
              <ion-text color="danger"
                ><small>Passwords do not match.</small></ion-text
              >
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center">
          <ion-button color="primary" type="submit" [disabled]="!f.valid"
            >Update Password
            <ion-icon slot="start" name="save-outline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-item color="lightmimbo" lines="none">
      <ion-text
        color="primary"
        (click)="goToChangePassword()"
        class="link forgot-password"
        >Forgot Password?</ion-text
      ></ion-item
    >
  </form>
</ion-content>
